(function ($) {
    'use strict';
    $(document).ready(function () {
    });

    $(window).load(function () {
        // To style all selects
        $('select[multiple]').selectpicker();
    });
})(jQuery);
